import { render, staticRenderFns } from "./TextVoiceThen.vue?vue&type=template&id=1a2717f0&scoped=true"
import script from "./TextVoiceThen.vue?vue&type=script&lang=js"
export * from "./TextVoiceThen.vue?vue&type=script&lang=js"
import style0 from "./TextVoiceThen.vue?vue&type=style&index=0&id=1a2717f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2717f0",
  null
  
)

export default component.exports